import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import { ADACodeConfigModel } from 'src/app/models/configuration/ADA-code-config.model';


@Injectable({
  providedIn: 'root'
})
export class AdacodeConfigService {

  constructor(private http: HttpClient) { }


  getApplicationProcedures(): Observable<any[]> {
    return this.http.get<any[]>(`api/feeSchedule/get-ada-code-config`);
  }


  saveApplicationProcedures(selectedRowData: ADACodeConfigModel ): Observable<ADACodeConfigModel> {
    return this.http.post<any>('api/feeSchedule/save-ada-code-config', selectedRowData);
  }


}
